import PropTypes from "prop-types";
import "./CartViewLayoutSection.css";

const CartViewLayoutSection = ({ layoutType, setLayoutType, onEditModeClick }) => {
  const handleLayoutViewFn = (e) => {
    const eventCapturedData = e.target?.closest("[data-layout-value]");
    if (!eventCapturedData) return;
    const layoutValue = eventCapturedData?.getAttribute("data-layout-value") ?? "cardViewLayout";
    setLayoutType(layoutValue);
  };

  return (
    <section className="cvls-wrap" onClick={(e) => handleLayoutViewFn(e)}>
      {/* Card view */}
      <button
        type="button"
        className={`cvls-btn ${layoutType === "cardViewLayout" ? "cvls-btn--active" : "cvls-btn--inactive"}`}
        aria-label="cardViewLayout"
        data-layout-value="cardViewLayout"
        title="Card view"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <rect width="7" height="7" x="3" y="3" rx="1" />
          <rect width="7" height="7" x="14" y="3" rx="1" />
          <rect width="7" height="7" x="14" y="14" rx="1" />
          <rect width="7" height="7" x="3" y="14" rx="1" />
        </svg>
      </button>

      {/* Row view */}
      <button
        type="button"
        className={`cvls-btn ${layoutType === "rowViewLayout" ? "cvls-btn--active" : "cvls-btn--inactive"}`}
        aria-label="rowViewLayout"
        data-layout-value="rowViewLayout"
        title="Row view"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
          style={{ transform: "rotate(45deg)" }} aria-hidden="true">
          <rect width="7" height="7" x="3" y="3" rx="1" />
          <rect width="7" height="7" x="14" y="3" rx="1" />
          <rect width="7" height="7" x="14" y="14" rx="1" />
          <rect width="7" height="7" x="3" y="14" rx="1" />
        </svg>
      </button>

      {/* List view */}
      <button
        type="button"
        className={`cvls-btn ${layoutType === "listViewLayout" ? "cvls-btn--active" : "cvls-btn--inactive"}`}
        aria-label="listViewLayout"
        data-layout-value="listViewLayout"
        title="List view"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <path d="M4 5h16" />
          <path d="M4 12h16" />
          <path d="M4 19h16" />
        </svg>
      </button>

      <button
        type="button"
        className="cvls-btn cvls-btn--edit"
        aria-label="Edit menu"
        data-testid="button-toggle-menu-edit-mode"
        title="Edit menu"
        onClick={(e) => {
          e.stopPropagation();
          onEditModeClick?.();
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <path d="M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z" />
          <path d="m15 5 4 4" />
        </svg>
      </button>
    </section>
  );
};

CartViewLayoutSection.propTypes = {
  layoutType: PropTypes.string.isRequired,
  setLayoutType: PropTypes.func.isRequired,
  onEditModeClick: PropTypes.func,
};

CartViewLayoutSection.defaultProps = {
  onEditModeClick: undefined,
};

export default CartViewLayoutSection;
